import { mutations } from './mutations'
import { actions } from './actions'

const state = {
    brands: [],
    isLoading: false
}

export const brands = {
    state,
    mutations,
    actions
}
